<template>
  <figure class="slider hidden-portable">
    <ul class="item" :style="`--item: ${slider.img.length}; left: -${100 * slider.index}%`">
      <li v-for="(item, index) in slider.img" :key="`slider-${index}`" :style="{backgroundImage: `url(${item})`}"></li>
    </ul>
    <div class="pagination" v-if="slider.img.length > 1">
      <ul>
        <li v-for="(item, index) in slider.img" :key="`li-${index}`" :class="slider.index === index && 'active'" @click.prevent="operate('point', index)"></li>
      </ul>
      <span>
        <svg viewBox="0 0 1024 1024" :class="slider.index === 0 && 'not'" @click.prevent="operate('perv', null)">
          <path d="M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z"></path>
        </svg>
        <svg viewBox="0 0 1024 1024" :class="slider.index === slider.img.length - 1 && 'not'" @click.prevent="operate('next', null)">
          <path d="M593.450667 512.128L360.064 278.613333l45.290667-45.226666 278.613333 278.762666L405.333333 790.613333l-45.226666-45.269333z"></path>
        </svg>
      </span>
    </div>
  </figure>
</template>

<script setup>
  import { useStore } from 'vuex';
  const store = useStore();
  const language = computed(() => store.getters.language.current);

  const slider = reactive({ img: [], index: 0, timer: null, t: null });

  const loadSlider = (cr) => {
    switch (cr) {
      case "JP":
        slider.img = ["/slideshow/jp/1.jpg", "/slideshow/jp/2.jpg", "/slideshow/jp/3.jpg"];
        break;
      default:
        slider.img = ["/slideshow/default/1.png", "/slideshow/default/2.png", "/slideshow/default/3.png"];
        break;
    }
  }

  const operate = (type, v) => {
    clearTimeout(slider.t);
    clearInterval(slider.timer);
    switch (type) {
      case "point": slider.index = v; break;
      case "perv": slider.index--; break;
      case "next": slider.index++; break;
    }
    slider.t = setTimeout(() => loop(), 6000)
  }

  const loop = () => {
    slider.timer = setInterval(() => {
      let { index, img } = slider;
      index >= img.length - 1 ? slider.index = 0 : slider.index++
    }, 6000)
  }

  watch(language, (v) => loadSlider(language.value.cr))

  onMounted(() => {
    loadSlider(language.value.cr);
    slider.img.length > 1 && loop()
  });
  onUnmounted(() => clearInterval(slider.timer))
</script>

<style scoped lang="less">
  .slider {
    width: 50%; max-width: 654px; height: 100%; overflow: hidden;
    position: absolute; z-index: 2; left: 0; top: 0; clip-path: polygon(100% 0, 91% 100%, 0 100%, 0 0);
  }
  .item {
    width: calc(100% * var(--item)); height: inherit; position: relative; transition: all 0.3s;
    display: grid; grid-template-columns: repeat(var(--item), 1fr);
    li {width: 100%; height: inherit; background-position: center; background-size: cover;}
  }
  .pagination {
    width: 100%; padding-left: 30px; padding-right: 90px; display: flex; justify-content: space-between; align-items: center;
    position: absolute; bottom: 30px; z-index: 2;
    ul {display: flex;}
    ul li {width: 50px; height: 2px; background: var(--normal-color); margin-right: 10px; cursor: pointer; opacity: 0.4; transition: opacity 0.3s;}
    ul li:last-child {margin-right: 0;}
    ul li.active {opacity: 1;}

    span {height: 36px;}
    svg {width: 36px; height: 36px; fill: var(--normal-color); cursor: pointer;}
    svg.not {opacity: 0.4; pointer-events: none;}
  }
  @media screen and (max-width: 1024px) {
    .slider {width: 40%;}
  }
</style>
